var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMnLogoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mn-logo",
    "data-name": "MN Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257 134.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1 letter-m",
    d: "M102.3,133.8V54.66l-24.4,79.14h-16.4L37.3,54.66v79.14H.5V.5H50.3l19.4,65.75L89.5,.5h49.4V133.8h-36.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1 letter-n",
    d: "M220.7,133.8l-35.8-68.55v68.55h-37.4V.5h38.4l33.4,64.55V.5h37.2V133.8h-35.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnLogoOutline);
export default __webpack_public_path__ + "static/media/mn-logo-outline.67e0a344baaa1d45e0f7f8ddd48b8b74.svg";
export { ForwardRef as ReactComponent };